"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberFromBN = exports.getBN = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
/**
 * Used for conversion of token amounts to their Big Number representation.
 * Get Big Number representation in the smallest units from the same value in the highest units.
 * @param {number} value - Number of tokens you want to convert to its BN representation.
 * @param {number} decimals - Number of decimals the token has.
 */
var getBN = function (value, decimals) {
    var decimalPart = value - Math.trunc(value);
    var integerPart = new bn_js_1.default(Math.trunc(value));
    var decimalE = new bn_js_1.default(decimalPart * 1e9);
    var sum = integerPart.mul(new bn_js_1.default(1e9)).add(decimalE);
    var resultE = sum.mul(new bn_js_1.default(10).pow(new bn_js_1.default(decimals)));
    return resultE.div(new bn_js_1.default(1e9));
};
exports.getBN = getBN;
/**
 * Used for token amounts conversion from their Big Number representation to number.
 * Get value in the highest units from BN representation of the same value in the smallest units.
 * @param {BN} value - Big Number representation of value in the smallest units.
 * @param {number} decimals - Number of decimals the token has.
 */
var getNumberFromBN = function (value, decimals) {
    return value.gt(new bn_js_1.default(Math.pow(2, 53) - 1))
        ? value.div(new bn_js_1.default(Math.pow(10, decimals))).toNumber()
        : value.toNumber() / Math.pow(10, decimals);
};
exports.getNumberFromBN = getNumberFromBN;
